


















import { Component, Mixins, Prop } from 'vue-property-decorator';
import LazyDropdown from '../LazyDropdown.vue';
import DropdownField from '../../mixins/DropdownField';
@Component({
  components: {
    LazyDropdown
  }
})
export default class PriorityProductLazyDropdown extends Mixins(DropdownField) {
  @Prop({ default: 'priority-products' })
  endPoint!: string;
  @Prop({ default: false })
  disabled!: boolean;
  @Prop({ default: '' })
  inputError!: string;

  title: string = '';
}
